import { ChatService } from "@/services/chat/chat.service";
import { State } from "@/store/modules/chat/index";

const _chatService = new ChatService();

const setUserChatAction = ({ commit }, payload) => {
  commit("setUserChat", payload);
};

const setMessagingSessionAction = ({ commit }, payload) => {
  commit("setMessagingSession", payload);
};

const setChatTypeAction = ({ commit }, payload) => {
  commit("setChatType", payload);
};

const addNewMessageAction = ({ commit }, payload) => {
  commit("addNewMessage", payload);
};

const setMessagesAction = ({ commit }, payload) => {
  commit("setMessages", payload);
};

const setUnSeenMessageAction = ({ commit }, payload) => {
  commit("setUnSeenMessage", payload);
};

const addUnSeenMessageAction = ({ commit }, payload) => {
  commit("addUnSeenMessage", payload);
};

const removeUnSeenMessageAction = ({ commit }, payload) => {
  commit("removeUnSeenMessage", payload);
};

const setNextTokenAction = ({ commit }, payload) => {
  commit("setNextToken", payload);
};

const setMinimizeChatAction = ({ commit }, payload) => {
  commit("setMinimizeChat", payload);
};

const setPinnedMessagesLengthAction = ({ commit }, payload) => {
  commit("setPinnedMessagesLength", payload);
};

const joinRoomChatAction = ({ commit }, { roomId, pinToJoin = null }) => {
  _chatService
    .joinRoomChat(roomId, pinToJoin)
    .then((response) => {
      // do nothing
    })
    .catch((error) => {
      console.log(error);
    });
};
const joinSpaceChatAction = ({ commit }, spaceId) => {
  _chatService
    .joinSpaceChat(spaceId)
    .then((response) => {
      // do nothing
    })
    .catch((error) => {
      console.log(error);
    });
};

const leaveRoomChatAction = ({ commit }, roomId) => {
  _chatService
    .leaveRoomChat(roomId)
    .then((response) => {
      // do nothing
    })
    .catch((error) => {
      console.log(error);
    });
};

const getEndPointUrlAction = ({ commit }, { callback }) => {
  _chatService
    .getChatEndpointUrl()
    .then((response) => {
      commit("setEndPointUrl", response.data.Endpoint.Url);
      callback();
    })
    .catch((error) => {
      console.log(error);
    });
};

const sendNewMessageAction = ({ commit }, { userId, data }) => {
  _chatService
    .sendChatMessage(userId, data)
    .then(() => {
      // do nothing
    })
    .catch((error) => {
      console.log(error);
    });
};

const sendRoomMessageAction = ({ commit }, { roomId, data }): void => {
  _chatService
    .sendRoomMessage(roomId, data)
    .then(() => {
      // do nothing
    })
    .catch((error) => {
      console.log(error);
    });
};
const sendSpaceMessageAction = ({ commit }, { spaceId, data }): void => {
  _chatService
    .sendSpaceMessage(spaceId, data)
    .then(() => {
      // do nothing
    })
    .catch((error) => {
      console.log(error);
    });
};
const getMessagesInChat = (
  { commit },
  { userId, nextToken = null, callback, callbackError }
): void => {
  _chatService
    .getMessagesInChat(userId, nextToken)
    .then((response) => {
      commit(
        !nextToken ? "setMessages" : "addMessages",
        response.data.ChannelMessages
      );
      commit("setNextToken", response.data.NextToken ?? null);
      callback();
    })
    .catch((error) => {
      callbackError(error);
    });
};
const getMessagesInSpaceChat = (
  { commit },
  { spaceId, nextToken = null, callback, callbackError }
) => {
  _chatService
    .getSpaceMessage(spaceId, nextToken)
    .then((response) => {
      commit(
        !nextToken ? "setMessages" : "addMessages",
        response.data.ChannelMessages
      );
      commit("setNextToken", response.data.NextToken ?? null);
      callback();
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getMessagesInRoomChatAction = (
  { commit },
  { roomId, nextToken = null, callback, callbackError }
) => {
  _chatService
    .getRoomMessage(roomId, nextToken)
    .then((response) => {
      commit(
        !nextToken ? "setMessages" : "addMessages",
        response.data.ChannelMessages
      );
      commit("setNextToken", response.data.NextToken ?? null);
      callback();
    })
    .catch((error) => {
      callbackError(error);
    });
};

const pinMessageAction = ({ commit }, { data, callback }) => {
  _chatService
    .pinMessage(data)
    .then((response) => {
      callback();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getPinnedMessageAction = (
  { commit },
  { id, spaceId, roomId = null, callback }
) => {
  _chatService
    .getPinnedMessage(id, spaceId, roomId)
    .then((response) => {
      commit(
        "setPinnedMessagesLength",
        response.headers["pagination-total-items"]
      );
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};
const deletePinnedMessageAction = ({ commit }, { id, callback }) => {
  _chatService
    .deletePinnedMessage(id)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getOpenChatsAction = (
  { commit },
  { spaceId, page, search, callback, callbackError }
) => {
  _chatService
    .getOpenChats(spaceId, page, search)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const clearChatAction = ({ commit }, { spaceId, callback, callbackError }) => {
  _chatService
    .clearChat(spaceId)
    .then((response) => {
      callback();
    })
    .catch((error) => {
      console.log(error);
      callbackError(error);
    });
};

export default {
  setUserChatAction,
  setMessagingSessionAction,
  joinRoomChatAction,
  leaveRoomChatAction,
  getEndPointUrlAction,
  sendNewMessageAction,
  setChatTypeAction,
  addNewMessageAction,
  addUnSeenMessageAction,
  removeUnSeenMessageAction,
  getMessagesInChat,
  sendRoomMessageAction,
  setMessagesAction,
  setUnSeenMessageAction,
  joinSpaceChatAction,
  sendSpaceMessageAction,
  getMessagesInSpaceChat,
  pinMessageAction,
  getPinnedMessageAction,
  deletePinnedMessageAction,
  getMessagesInRoomChatAction,
  setNextTokenAction,
  getOpenChatsAction,
  setMinimizeChatAction,
  setPinnedMessagesLengthAction,
  clearChatAction,
};
